{
  "de": {
    "timestamp": {
      "labels": {
        "accepted": "Akzeptiert am {date}",
        "ago": "her",
        "daysAgo": "{days} Tag |{days} Tage",
        "daysRemaining": "{days} Tage verbleibend",
        "due": "Fällig am {date}",
        "dueToday": "Heute fällig",
        "expired": "Abgelaufen am {date}",
        "hoursAgo": "{hours} Stunde | {hours} Stunden",
        "in": "In {time}",
        "justNow": "Gerade eben",
        "minutesAgo": "{minutes} Minute | {minutes} Minuten",
        "monthsAgo": "{months} Monat | {months} Monate",
        "noDeadline": "Keine Frist festgelegt",
        "overdue": "{days} Tage überfällig",
        "sentOn": "Gesendet am {date}",
        "sentOnAt": "Gesendet am {date} um {time}",
        "starts": "Beginnt am {date}",
        "today": "Heute",
        "tomorrow": "Morgen",
        "uploaded": "Hochgeladen am {date}",
        "weeksAgo": "{weeks} Woche | {weeks} Wochen",
        "yearsAgo": "{years} Jahr | {years} Jahre",
        "yesterday": "Gestern"
      }
    }
  }
}
